
console.log('glossary scanner js');
// Function to parse CSV text into an object
function parseCSVToObj(csvText) {
        const lines = csvText.split('\n');
        const result = {};

        // Skip the header by starting from index 1
        lines.slice(1).forEach(line => {
            let term = '';
            let definition = '';
            let isInQuotes = false;
            let field = '';
            for (let i = 0; i < line.length; i++) {
                const char = line[i];
                if (char === '"' && (i === 0 || line[i-1] !== '"')) { // Ignore double quotes
                    isInQuotes = !isInQuotes;
                    continue;
                }
                if (char === ',' && !isInQuotes) {
                    if (!term) {
                        term = field;
                        field = '';
                    } else {
                        // This handles the case of commas within definitions
                        field += char;
                    }
                } else {
                    field += char;
                }
            }
            definition = field; // The last field after the loop is the definition

            // Remove starting and ending quotes from the definition, if present
            if (definition.startsWith('"') && definition.endsWith('"')) {
                definition = definition.substring(1, definition.length - 1);
            }

            // Replace any double quotes inside the field with a single quote
            definition = definition.replace(/""/g, '"');

            // Trim the term and definition to remove any accidental whitespace
            term = term.trim();
            definition = definition.trim();

            result[term] = definition;
        });

        return result;
    }

    // Helper function to escape special characters for regular expressions
    function escapeRegExp(string) {
        return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
    }

    // // Function to scan article content for terms and log their definitions
    // function scanArticleForTerms(termsDefinitions, articleContent) {
    //     articleContent.forEach(paragraph => {
    //         // Find all text nodes in the paragraph using a TreeWalker
    //         const walker = document.createTreeWalker(paragraph, NodeFilter.SHOW_TEXT, null, false);
    //         let node;
    //         while ((node = walker.nextNode())) {
    //             Object.keys(termsDefinitions).forEach(term => {
    //                 const escapedTerm = escapeRegExp(term);
    //                 const regex = new RegExp(`(?<!title=")\\b(${escapedTerm})\\b`, 'gi');
    //                 // Check if the current text node contains the term
    //                 if (regex.test(node.nodeValue)) {
    //                     const replacementHtml = node.nodeValue.replace(regex, (match) => {
    //                         // Return the matched term with the icon HTML appended
                                // const icon = document.querySelector('#info_icon-wrapper .glossary_icon');
                                // icon.setAttribute('data-term', term);
    //                         const infoIcon = '<span class="icon glossary_info-icon" data-icon="info"> <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><g id="info"><path d="M50,7A43,43,0,1,0,93,50,43,43,0,0,0,50,7Zm6.93,68.29a6.68,6.68,0,0,1-6.88,6.45,7.1,7.1,0,0,1-4.86-1.89,6.25,6.25,0,0,1-2-4.56V45.72a6.67,6.67,0,0,1,6.87-6.44,7.14,7.14,0,0,1,4.87,1.88,6.25,6.25,0,0,1,2,4.56ZM50,33.05a7.4,7.4,0,1,1,7.39-7.4A7.39,7.39,0,0,1,50,33.05Z"></path></g></svg></span>'
    //                         return `${match}${infoIcon}`;
    //                     });

    //                     // Create a temporary div to hold the replacement HTML
    //                     const tempDiv = document.createElement('div');
    //                     tempDiv.innerHTML = replacementHtml;

    //                     // Replace the current text node with the contents of the temporary div
    //                     while (tempDiv.firstChild) {
    //                         // Insert before the current text node if the tempDiv has children
    //                         node.parentNode.insertBefore(tempDiv.firstChild, node);
    //                     }
    //                     // Remove the original text node
    //                     node.parentNode.removeChild(node);
    //                 }
    //             });
    //         }
    //     });
    // }

    // Function to scan article content for terms and log their definitions
    function scanArticleForTerms(termsDefinitions, articleContent) {
        articleContent.forEach(paragraph => {
            let modifiedHTML = paragraph.innerHTML; // Work directly with HTML content

            Object.keys(termsDefinitions).forEach(term => {
                // Escape term for regex and use word boundaries
                const escapedTerm = escapeRegExp(term);
                // Modify the regex pattern to account for the start and end of the term within the HTML content
                const regex = new RegExp(`(?<!=\")\\b(${escapedTerm})\\b`, 'gi');

                
                modifiedHTML = modifiedHTML.replace(regex, (match) => {
                    // Append the icon HTML to the matched term
                    const icon = document.querySelector('#info_icon-wrapper .glossary_icon');
                    icon.setAttribute('data-term', term);
                    // const infoIcon = '<span class="icon glossary_info-icon" data-icon="info"> <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><g id="info"><path d="M50,7A43,43,0,1,0,93,50,43,43,0,0,0,50,7Zm6.93,68.29a6.68,6.68,0,0,1-6.88,6.45,7.1,7.1,0,0,1-4.86-1.89,6.25,6.25,0,0,1-2-4.56V45.72a6.67,6.67,0,0,1,6.87-6.44,7.14,7.14,0,0,1,4.87,1.88,6.25,6.25,0,0,1,2,4.56ZM50,33.05a7.4,7.4,0,1,1,7.39-7.4A7.39,7.39,0,0,1,50,33.05Z"></path></g></svg></span>'
                    
                    return `${match}${icon.outerHTML}`;
                });
            });
            
            // Update the paragraph's HTML only if changes have been made
            if (paragraph.innerHTML !== modifiedHTML) {
                paragraph.innerHTML = modifiedHTML;
            }
        });
    }

    let termsDefinitions = {}
    
    function fetchCSVAndScanArticle(csvUrl) {
    // Function to fetch and parse the CSV data
        fetch(csvUrl)
            .then(response => response.text())
            .then(text => {
                termsDefinitions = parseCSVToObj(text);
                // console.log(termsDefinitions);
                scanArticleForTerms(termsDefinitions, document.querySelectorAll('.article-content p'));
            })
            .catch(error => console.error('Error fetching or parsing CSV:', error));
    }


    document.addEventListener('DOMContentLoaded', () => {

        // Extract file url from Shopify section settings and parse it
        const sectionUrl = document.getElementById('glossary_file_url-container').dataset.file;
        fetchCSVAndScanArticle(sectionUrl);

        document.querySelector('.article-content').addEventListener('click', function(e) {

            // Check if the clicked element or its parent is an a tag with an info icon
            const aTag = e.target.closest('a');
            if (aTag && aTag.querySelector('.icon.glossary_icon')) {
                e.preventDefault(); // Prevent the default hyperlink action

                // console.log("event target:", e.target);

                // Retrieve the term directly from the 'a' tag or its child '.icon.glossary_icon'
                const iconElement = aTag.querySelector('.icon.glossary_icon');
                const term = iconElement.getAttribute('data-term');
                const definition = termsDefinitions[term]; // Assuming termsDefinitions is accessible
                
                // console.log("Term:", term, "Definition:", definition);
                
                // Populate the term and definition in the popup
                document.getElementById('term').textContent = term;
                document.getElementById('definition').textContent = definition;
                
                const popup = document.getElementById('glossary_popup');
                const iconRect = iconElement.getBoundingClientRect();


        
                // Show the popup to ensure its dimensions can be measured
                popup.style.display = 'block';
                const popupHeight = popup.offsetHeight;
                const popupWidth = popup.offsetWidth;

                // Screen width condition for centering the popup
                const screenWidth = window.innerWidth;
                let leftPosition = 0;
                if (screenWidth <= 480) {
                    leftPosition = (screenWidth - popupWidth) / 2;
                } else {
                    leftPosition = iconRect.left + window.scrollX + (iconRect.width / 2) - (popupWidth / 2);

                    // Ensure the popup does not overflow off the left or right side of the screen
                    if (leftPosition < 0) {
                        leftPosition = 10; // A small padding from the left edge
                    } else if ((leftPosition + popupWidth) > screenWidth) {
                        leftPosition = screenWidth - popupWidth - 10; // A small padding from the right edge
                    }
                }

                // Calculate topPosition based on the available space above the icon
                let topPosition = iconRect.top + window.scrollY - popupHeight - 10; // Default above the icon\
                console.log(iconRect.top)

                // Check if the space above the icon is shorter than the modal height
                if (iconRect.top < popupHeight + 10) { // 10px as a buffer space
                    // Position the modal beneath the icon if not enough space above
                    topPosition = iconRect.bottom + window.scrollY + 10; // 10px below the icon
                }

                popup.style.left = `${leftPosition}px`;
                popup.style.top = `${topPosition}px`;

            }
        });
    
        // Optional: Hide the popup when clicking anywhere outside
        document.addEventListener('click', function(e) {
            const popup = document.getElementById('glossary_popup');
            const aTagWithIcon = e.target.closest('a') && e.target.closest('a').querySelector('.icon.glossary_icon');
            const closeIcon = document.getElementById('glossary_close');

            if (closeIcon.contains(e.target)) {
                popup.style.display = 'none';
            }
            else if (!e.target.closest('#glossary_popup') && !aTagWithIcon) {
                popup.style.display = 'none';
            } 
        });
    });








